import { render, staticRenderFns } from "./TopicsChart.vue?vue&type=template&id=d000802e&"
import script from "./TopicsChart.vue?vue&type=script&lang=js&"
export * from "./TopicsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports